import React from 'react'
import { FaRegTrashAlt } from 'react-icons/fa'

import './ImageContainer.css'
import { BtnIcon } from '../'

function ImageContainer({ imagePath, alt, onBtnDeleteClicked }) {
  return (
    <div className="ImageContainer">
      <img src={imagePath} alt={alt} style={{ maxWidth: 600 }} />
      <div className="image_backdrop image_backdrop_show">
        <div className="btn_container">
          <BtnIcon onClick={onBtnDeleteClicked}>
            <FaRegTrashAlt color="red" size={26} />
          </BtnIcon>
        </div>
      </div>
    </div>
  )
}

export default ImageContainer
